import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import { UnmountClosed } from 'react-collapse';
import { useParams } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../components/helpers/Translator';
import colors from '../../../../../../constants/colors';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import { getActionPlanState } from '../../tools/totalEnergiesRiskActionPlanTools';
import TotalEnergiesRiskActionPlanExpandedContainer from './TotalEnergiesRiskActionPlanExpandedContainer';

export default function ActionPlanDefault({ elementID }) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const actionPlanLevel1 = useSelector(
    (state) => state?.currentPage?.elementLevels?.level1?.[elementID],
  );
  const actionPlanExpandedID = useSelector(
    (s) => s.currentPage?.actionPlanExpandedID,
  );
  const permissionsLevel = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge?.permissions?.level,
  );
  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    if (
      (actionPlanLevel1 &&
        actionPlanExpandedID &&
        actionPlanLevel1?.id === actionPlanExpandedID) ||
      permissionsLevel === 1
    ) {
      setIsOpened(true);
      dispatch(currentPageAction.change('actionPlanExpandedID', undefined));
    }
  }, [actionPlanLevel1, actionPlanExpandedID]);

  if (!actionPlanLevel1) {
    return (
      <LoaderContainer key={elementID} className="mb-1">
        <div className="card default">
          <div className="card-body" />
        </div>
      </LoaderContainer>
    );
  }

  return (
    <Container
      key={elementID}
      $bgColor={colors?.totalEnergiesRiskActionPlanState[actionPlanLevel1?.state]}
      className="mb-1"
    >
      <AppCard bodyClassName="p-0 default" headerClassName="p-0">
        <div className="default-content">
          <div className="content">
            <div
              className="state"
              title={getActionPlanState(actionPlanLevel1?.state)}
            >
              {actionPlanLevel1?.state === 2 && (
                <AppRemixIcon icon="delete-bin" color="#fff" size={20} />
              )}
            </div>
            <div className="content-col">
              <div className="text-primary header container-header mb-2">
                <div />
                <div>{actionPlanLevel1?.code}</div>
              </div>
              <div className="text-primary header container-header">Descripción:</div>
              <div>{actionPlanLevel1?.description}</div>
            </div>
            <div className="content-col third-col">
              <div className="column">
                <div className="text-primary header">Fecha de inicio:</div>
                <div>{actionPlanLevel1?.startDateStamp || '--'}</div>
              </div>
              <div className="column">
                <div className="text-primary header">Fecha de terminación:</div>
                <div>{actionPlanLevel1?.endDateStamp || '--'}</div>
              </div>
            </div>
            <div className="content-col third-col">
              <div className="column">
                <div className="text-primary header container-header">
                  Fecha de creación:
                </div>
                <div>{actionPlanLevel1?.dateStamp}</div>
                <div className="text-primary header">Fecha última modificación:</div>
                <div>{actionPlanLevel1?.modificationDateStamp || '--'}</div>
              </div>
              <div className="column">
                <div className="text-primary header">Responsable:</div>
                <div>{actionPlanLevel1?.responsibleName || '--'}</div>
                <div className="text-primary header">Fecha prevista revisión:</div>
                <div>{actionPlanLevel1?.scheduledReviewDate || '--'}</div>
              </div>
            </div>
          </div>
          <div className="expand pointer" onClick={() => setIsOpened(!isOpened)}>
            <AppRemixIcon icon={isOpened ? 'subtract' : 'add'} color="white" />
          </div>
        </div>
      </AppCard>
      <UnmountClosed isOpened={isOpened}>
        <TotalEnergiesRiskActionPlanExpandedContainer elementID={elementID} />
      </UnmountClosed>
    </Container>
  );
}

const LoaderContainer = styled.div`
  & > .card {
    height: 126px;
  }
`;

const Container = styled.div`
  & > .card {
    height: 126px;
    border-radius: 5px;
    border: 1px solid;
  }

  .default-content {
    display: grid;
    grid-template-columns: 1fr 40px;

    .content {
      display: grid;
      grid-template-columns: 40px 1fr 1fr 1fr;

      .state {
        background-color: ${(props) => props?.$bgColor};
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .content-col {
        border-right: 1px solid #ccc;
        padding: 6px;
        overflow-y: auto;
        height: 124px;
        font-size: 12px;

        .container-header {
          display: flex;
          flex: auto;
          justify-content: space-between;
        }

        .header {
          font-weight: bold;
        }

        &.third-col {
          display: flex;
          justify-content: space-around;
          align-items: center;

          .column {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
      }
    }
    & > .expand {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 2px;
      font-size: 20px;
      height: 120px;
      margin: 2px;
      background-color: ${colors.primary};
    }
  }
`;
